module.exports = __webpack_public_path__ + "img/officialCustomerService.735550df.jpg";